import { apiFetch } from './client';

// Per-user notification channel preferences (internal/api/me.go). Cross-org —
// these follow the user, so the endpoints live under /me, not under an org.

export interface NotificationPreference {
  // Stable kind identifier, e.g. 'calling_received'.
  kind: string;
  email_enabled: boolean;
  push_enabled: boolean;
}

interface NotificationPreferencesResponse {
  preferences: NotificationPreference[];
}

export async function listNotificationPreferences(
  token: string | null,
): Promise<NotificationPreference[]> {
  const res = await apiFetch<NotificationPreferencesResponse>(
    '/api/v1/me/notification-preferences',
    { token },
  );
  return res.preferences;
}

export async function updateNotificationPreference(
  token: string | null,
  kind: string,
  input: { email_enabled: boolean; push_enabled: boolean },
): Promise<NotificationPreference> {
  return apiFetch<NotificationPreference>(
    `/api/v1/me/notification-preferences/${encodeURIComponent(kind)}`,
    { method: 'PUT', body: input, token },
  );
}
